<app-real-estate-detail></app-real-estate-detail>